// Copy right - © 2024 tecera gmbh

import App from './App.svelte';



const app = new App({
	target: document.body,
	props: {
	}
});



export default app;